import * as z from "zod";

export const markUnableToPick = {
  name: "markUnableToPick" as const,
  input: z.object({
    pickLineId: z.string(),
    quantityUnableToPick: z.number().int().positive(),
    sessionId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    quantityPicked: z.number(),
    quantityRemaining: z.number(),
  }),
};
